
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import MAddConceptInvoice from "../../../../../components/global/Modals/MAddConceptInvoice";
import { AMInvoiceActions } from "../../../../../components/global/Modals/ActionModal/AMInvoiceActions";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import { useExportInvoicesMutation, useFinalizeAllInvoicesMutation, useGetInvoicesQuery, useMarkInvoicesPaidMutation, useSendInvoiceRemindersMutation } from "../../../../../newapi/financial/invoiceSlice";
import { general_states } from "../../../../../utils/staticEnums";
import ShDataGridSelectedActions from "../../../../../components/theme/datagrid2/ShDataGridSelectedActions";
import DropdownButton from "../../../../../components/theme/buttons/DropdownButton";
import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import CallMadeOutlinedIcon from '@mui/icons-material/CallMadeOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
// import SpRelationDetails from "../../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails";
// import SpInvoiceDetails from "../../../../../components/global/Sidepanels/SpInvoiceDetails/SpInvoiceDetails";
import { WarehouseInvoiceCard } from "../../../../../components/global/cards/financial/InvoiceCard";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { formatPrice } from "../../../../../utils/helpers";
import { getInvoiceStateData } from "../../../../../utils/labelColorText";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import { INVOICE_FILTER_KEYS } from "../../../../../components/global/DataGrid/Filter";
import ShCopyButton from '../../../../../components/theme/ShCopy';
import SHQuickAction from '../../../../../components/theme/Modal/SHQuickAction';
import MDynamicValues from "../../../../../components/global/Modals/MDynamicValues";
import { useGetRelationsSelectQuery } from "../../../../../newapi/global/relation/relationSlice";
import { showToastMessage, showToastMessagePostRequest, showToastMessageRequestError } from "../../../../../utils/toasts";
import MLoader from "../../../../../components/global/Modals/MLoader";
import MImportData from "../../../../../components/global/Modals/MImportData";
import MConfirmation from "../../../../../components/global/Modals/MConfirmation";
import { ImportStandAloneFileLogo, adjustmentChargeShipperOptions, adjustmentChargeReturnShippers } from "../../../../../utils/importColumnDefinitions";
import { useGetSettingsQuery } from "../../../../../newapi/global/generalApiSlice";
import { useGetInvoiceProductsSelectQuery } from "../../../../../newapi/financial/invoiceProductSlice";
import { AdjustmentChargeSkipList, AdjustmentChargeProductMapping, buildAdjustmentChargeOptions } from "../../../../../components/global/shared/AdjustmentChargeImportOptions";
import { useSaveAdjustmentChargeOptionsMutation } from "../../../../../newapi/global/uploadApiSlice";

const SpRelationDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails"));
const SpInvoiceDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpInvoiceDetails/SpInvoiceDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleActionsClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleActionsClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <ButtonGroup version={2}>
                <Shbutton
                    onClick={props.handleExportClick}
                    className={"group-btn"}
                    color={"primaryGrey"}
                    variant="contained"
                    endIcon={<DownloadOutlinedIcon/>}
                >
                    {t('export')}
                </Shbutton>
                {props.hasModifyPrivilege && (
                <Shbutton
                    className={"group-btn"}
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    onClick={handleActionsClick}
                    endIcon={<MoreVertIcon/>}
                    variant="contained"
                >
                    {t('actions')}
                </Shbutton>
                )}
            </ButtonGroup>
            <AMInvoiceActions
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleActionsClose}
                onAddConceptInvoice={() => props.handleOpen(true)}
                onImportAdjustmentCharges={() => props.handleImportOpen(true)}
                onFinalizeAllInvoices={() => props.handleFinalizeOpen(true)}
            />
        </>
    )
}

// An invoice is followed up on once it is out the door and still unpaid; those are the only rows
// that can be marked paid or reminded, so they are the only ones that get a checkbox.
const followUpStates = [general_states.SENT, general_states.REMINDED];

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [INVOICE_FILTER_KEYS.RELATION, INVOICE_FILTER_KEYS.STATE, INVOICE_FILTER_KEYS.OVERDUE],
};

const All = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [isRelationExtended, setIsRelationExtended] = useState(false);
    const [spRelationLoading, setSpRelationLoading] = useState();
    // const [selectedRowId, setSelectedRowId] = useState(-1);
    // const [rowSelected, setRowSelected] = useState(false);
    
    const ref = useRef();
    const [config, setConfig] = useState();

    const hasModifyPrivilege = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.INVOICE_MANAGE])
    );

    // Paying and reminding is only ours to do when Stockhub sends the invoices itself; with any
    // other accounting integration the invoice state is maintained on that side.
    const [isStockhubPdf, setIsStockhubPdf] = useState(false);
    const canFollowUp = hasModifyPrivilege && isStockhubPdf;

    const [selectedItems, setSelectedItems] = useState([]);
    const onSelected = (selectedItems) => {
        setSelectedItems(selectedItems);
    }

    const [markInvoicesPaid, {isLoading: isMarkingPaid}] = useMarkInvoicesPaidMutation();
    const handleMarkPaid = async () => {
        try {
            if (isMarkingPaid) return;

            const response = await markInvoicesPaid({invoiceIds: selectedItems}).unwrap();
            showToastMessagePostRequest(t, response);
            setSelectedItems([]);
        } catch (err) {
            showToastMessageRequestError(t("mark_as_paid_failed"), t, err);
        }
    }

    const [markPaidOpen, setMarkPaidOpen] = useState(false);
    const markPaidModal = {
        open: markPaidOpen,
        setOpen: setMarkPaidOpen
    }

    const [sendInvoiceReminders, {isLoading: isSendingReminders}] = useSendInvoiceRemindersMutation();
    const handleSendReminders = async () => {
        try {
            if (isSendingReminders) return;

            const response = await sendInvoiceReminders({invoiceIds: selectedItems}).unwrap();
            showToastMessagePostRequest(t, response);
            setSelectedItems([]);
        } catch (err) {
            showToastMessageRequestError(t("send_reminder_failed"), t, err);
        }
    }

    const [sendReminderOpen, setSendReminderOpen] = useState(false);
    const sendReminderModal = {
        open: sendReminderOpen,
        setOpen: setSendReminderOpen
    }

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[]);

    // The totals panel lives above the tab view, in the parent, and belongs to this tab only.
    // Report that this tab is open so it shows, and that it closed so it goes away again.
    useEffect(() => {
        props.onActiveChange?.(true);

        return () => props.onActiveChange?.(false);
    },[]);

    const handleOpen = () => {
        setAddModalOpen(true);
    }

    const handleImportOpen = () => {
        setImportModalOpen(true);
    }

    const handleFinalizeOpen = () => {
        setFinalizeModalOpen(true);
    }

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const [importModalOpen, setImportModalOpen] = useState(false);
    const importModal = {
        open: importModalOpen,
        setOpen: setImportModalOpen
    }

    const [finalizeModalOpen, setFinalizeModalOpen] = useState(false);
    const finalizeModal = {
        open: finalizeModalOpen,
        setOpen: setFinalizeModalOpen
    }

    const [finalizeLoaderModalOpen, setFinalizeLoaderModalOpen] = useState(false);
    const [finalizeResponseMessage, setFinalizeResponseMessage] = useState(null);
    const finalizeLoaderModal = {
        open: finalizeLoaderModalOpen,
        setOpen: setFinalizeLoaderModalOpen,
    };

    const handleClose = (invoiceId) => {
        setAddModalOpen(false);
        if (!isNaN(parseInt(invoiceId))) {
         getInvoice({row: {id: invoiceId}});
        }
    };

    const handleImportClose = () => {
        setImportModalOpen(false);
    };

    const handleFinalizeClose = () => {
        setFinalizeModalOpen(false);
    };

    const [finalizeAllInvoices, { isLoading: isFinalizing }] = useFinalizeAllInvoicesMutation();

    const handleFinalizeAllInvoices = async () => {
        try {
            finalizeModal.setOpen(false);
            finalizeLoaderModal.setOpen(true);
            setFinalizeResponseMessage(null);

            const response = await finalizeAllInvoices().unwrap();

            if (response.success) {
                finalizeLoaderModal.setOpen(false);
                showToastMessage("success", t("invoices_finalized"));
            } else {
                setFinalizeResponseMessage(response.message || t("finalize_all_invoices_success"));
            }
        } catch (error) {
            console.error('Error finalizing invoices:', error);
            finalizeLoaderModal.setOpen(false);
            showToastMessageRequestError(t("finalize_failed"), t, error);
        }
    };

    const handleFinalizeLoaderClose = () => {
        setFinalizeLoaderModalOpen(false);
        setFinalizeResponseMessage(null);
    };
        
    const { data: relationData, relationIsLoading } = useGetRelationsSelectQuery();

    const [exportInvoicesModalOpen, setExportInvoicesModalOpen] = useState(false);
    const exportInvoicesModal = {
        open: exportInvoicesModalOpen,
        setOpen: setExportInvoicesModalOpen
    }

    const [loaderModalOpen, setLoaderModalOpen] = useState(false);
    const loaderModal = {
        open: loaderModalOpen,
        setOpen: setLoaderModalOpen,
    };

    const [exportInvoices, {isLoading: isExporting}] = useExportInvoicesMutation();
    const handleExportInvoices = async (values) => {
        try {
            if(isExporting) return;

            if (!values.startDate || !/^\d{4}-\d{2}-\d{2}$/.test(values.startDate)) {
                showToastMessage("error", t("invalid_startdate"));
                return;
            }

            if (!values.endDate || !/^\d{4}-\d{2}-\d{2}$/.test(values.endDate)) {
                showToastMessage("error", t("invalid_enddate"));
                return;
            }

            // Validate date range does not exceed 31 days
            const startDateCheck = new Date(values.startDate);
            const endDateCheck = new Date(values.endDate);
            const daysDiff = Math.ceil((endDateCheck - startDateCheck) / (1000 * 60 * 60 * 24));

            if (daysDiff > 32) {
                showToastMessage("error", t("date_range_max_32_days"));
                return;
            }

            loaderModal.setOpen(true);

            exportInvoices(values).unwrap()
            .then(res => {
                showToastMessage("success", t("export_ready"));
            })
            .catch(e => {
                console.error(e);
                showToastMessage("error", t("export_failed"));
            })
            .finally(() => {
                loaderModal.setOpen(false);
            })
        } catch (error) {
            console.error("Export failed", error);
        }
    }

    // The Stockhub layout; a carrier invoice has the columns of that carrier instead.
    const importColumns = [
        {
            column: "Webshopreferentie",
            required: true
        },
        {
            column: "Tracking",
            required: true
        },
        {
            column: "Naheffing",
            required: true
        },
        {
            column: "Omschrijving",
            required: true
        }
    ];

    // The naheffingen import options are kept per shipper, so the shipper picked in the
    // modal decides which stored options the other fields start from. The options go along
    // with the file and are stored by the import.
    const [adjustmentChargesShipper, setAdjustmentChargesShipper] = useState("stockhub");
    const { data: adjustmentChargeSettings } = useGetSettingsQuery("adjustmentcharges");
    const { data: adjustmentChargeProducts } = useGetInvoiceProductsSelectQuery("adjustment_charges,surcharges");
    const [saveAdjustmentChargeOptions] = useSaveAdjustmentChargeOptionsMutation();

    // Stores the options without importing, so a configuration survives closing the modal.
    const handleAdjustmentChargesOptionsSave = async (values) => {
        try {
            await saveAdjustmentChargeOptions({ shipperType: values.shipperType, options: buildAdjustmentChargeOptions(values) }).unwrap();
            showToastMessage("success", t("update_successfull"));
        } catch (error) {
            showToastMessageRequestError(t("update_failed"), t, error);
        }
    };

    const adjustmentChargeImportSettings = useMemo(() => {
        const stored = adjustmentChargeSettings?.find(setting => setting.key === `adjustmentcharges_import_${adjustmentChargesShipper}`)?.objectBody ?? {};

        return [
            {
                name: "shipperType",
                label: t("shipper"),
                type: "list",
                defaultValue: adjustmentChargesShipper,
                options: adjustmentChargeShipperOptions,
                onChange: (shipperType) => setAdjustmentChargesShipper(shipperType)
            },
            ...(adjustmentChargeReturnShippers.includes(adjustmentChargesShipper) ? [{
                name: "includeReturns",
                label: t("adjustment_charges_include_returns"),
                type: "boolean",
                defaultValue: stored.includeReturns === true
            }] : []),
            {
                name: "skip",
                label: t("adjustment_charges_skip"),
                type: "custom",
                defaultValue: stored.skip ?? [],
                render: ({ value, onChange }) => <AdjustmentChargeSkipList value={value} onChange={onChange} />
            },
            {
                name: "products",
                label: t("adjustment_charges_products"),
                type: "custom",
                defaultValue: stored.products ?? [],
                render: ({ value, onChange }) => <AdjustmentChargeProductMapping value={value} onChange={onChange} invoiceProducts={adjustmentChargeProducts} />
            }
        ];
    }, [adjustmentChargeSettings, adjustmentChargesShipper, adjustmentChargeProducts, t]);

    const [relationId, setRelationId] = useState();
    const relationIdRef = useRef(relationId);
    
    const getRelationDetails = (params) => {
        if (!params && params.row) return;
    
        const newRelationId = parseInt(params.row.relation.id);
        // Only update state if the productId has actually changed
        if (relationIdRef.current !== newRelationId) {
            if(!spRelationLoading) {
                setSpRelationLoading(true);
            }
            setRelationId(newRelationId);
            relationIdRef.current = newRelationId; // Update the ref to the new value
        }
        setIsRelationExtended(true);
    };

    // comment for new version testbranch

    const [invoiceId, setInvoiceId] = useState();
    const invoiceIdRef = useRef(invoiceId);
    
    const getInvoice = (params) => {
        if (!params) return;
    
        const newInvoiceId = parseInt(params.row.id);
        // Only update state if the pickingJobListId has actually changed
        if (invoiceIdRef.current !== newInvoiceId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setInvoiceId(newInvoiceId);
            invoiceIdRef.current = newInvoiceId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const getYesterDay = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday.toLocaleDateString(i18n.language);
    }

    const columns = [
        {
            field: "number",
            headerName: t("number"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                gap:1.5,
                            }}
                        >
                            <Text noBreak>{params.row.number}</Text>
                            {params.row.creditedInvoice &&
                                <SHQuickAction
                                    disableScrollLock={true}
                                    component={
                                        <Box
                                            sx={{
                                                px:1.5,
                                                display:"flex",
                                                flexDirection:"column"
                                            }}
                                        >
                                            <Text light>{t("credited_invoice")}</Text>
                                            <Text bold>#{params.row.creditedInvoice.number}</Text>
                                        </Box>
                                    }
                                >
                                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                        <Box
                                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                                            aria-haspopup={false}
                                            onMouseEnter={onMouseEnter}
                                            onMouseLeave={onMouseLeave}
                                            onTouchStart={onTouchStart}
                                            onClick={(event) => {
                                                event.stopPropagation(); // Open the credited invoice instead of this row
                                                getInvoice({ row: { id: params.row.creditedInvoice.id } });
                                            }}
                                            sx={{
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                height:32,
                                                width:32,
                                                flexShrink:0,
                                                cursor:"pointer",
                                                color: colors.txt['secondary'],
                                                display:'flex',
                                                alignItems:'center',
                                                justifyContent:'center',
                                                borderRadius:4,
                                            }}
                                        >
                                            <ReceiptLongIcon fontSize='small'/>
                                        </Box>
                                    )}
                                </SHQuickAction>
                            }
                        </Box>
                        <ShCopyButton
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.number}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {field: "relation", headerName: t("relation"),flex:1, 
            filter: INVOICE_FILTER_KEYS.RELATION,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            const handleClick = (event) => {
                event.stopPropagation(); // Prevent click from propagating to the row
                getRelationDetails(params);
            };
            return (
                <Box sx={{height:1,display:"flex",alignItems:'center'}} onClick={handleClick}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.relation?.name}</Text>
                </Box>
            );
        }},
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            filter: INVOICE_FILTER_KEYS.STATE,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const stateData = getInvoiceStateData(params.row.state, theme);
                let labelcolor = stateData.labelcolor;
                let labeltext = stateData.labeltext;
                
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        {
            field: "date", 
            headerName: t("invoice_date"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = params.row.date && params.row.date !== null ? new Date(params.row.date) : undefined;
                let dateFinalized = params.row.dateFinalized ? new Date(params.row.dateFinalized) : undefined;

                if (!dateFinalized) {
                    return (
                        <Text>
                            {date ? date.toLocaleDateString(i18n.language) : "-"}
                        </Text>
                    );
                }

                // Hovering the invoice date reveals when the invoice was finalized
                return (
                    <SHQuickAction
                        component={
                            <Box sx={{ px: 1, display: "flex", flexDirection: "column", gap: 0.5 }}>
                                <Text bold noBreak>{t("finalized_on")}</Text>
                                <Text noBreak>{dateFinalized.toLocaleString(i18n.language)}</Text>
                            </Box>
                        }
                    >
                        {({ anchorEl, onMouseEnter, onMouseLeave, onTouchStart }) => (
                            <Box
                                aria-owns={anchorEl ? 'simple-popover' : undefined}
                                aria-haspopup="true"
                                onMouseEnter={onMouseEnter}
                                onMouseLeave={onMouseLeave}
                                onTouchStart={onTouchStart}
                            >
                                <Text>
                                    {date ? date.toLocaleDateString(i18n.language) : "-"}
                                </Text>
                            </Box>
                        )}
                    </SHQuickAction>
                );
            }
        },
        {
            field: "dueDate",
            headerName: t("due_date"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let dueDate = params.row.dueDate && params.row.dueDate !== null ? new Date(params.row.dueDate) : undefined;

                // An unpaid invoice past its due date is the one the warehouse has to act on.
                const isOverdue = dueDate && dueDate < new Date() && followUpStates.includes(params.row.state);

                return (
                    <Text sx={isOverdue ? {color: colors.red[400]} : undefined}>
                        {dueDate ? dueDate.toLocaleDateString(i18n.language) : "-"}
                    </Text>
                );
            }
        },
        {
            field: "totalPrice", 
            headerName: t("total_price"),
            flex:1,
            shFilter: {
                type: "number"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return formatPrice(i18n, params.row.totalPrice);
            }
        },
        {
            field: "period", 
            headerName: t("period"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let startDate = params.row.startDate && params.row.startDate !== null ? new Date(params.row.startDate) : undefined;
                let endDate = params.row.endDate && params.row.endDate !== null ? new Date(params.row.endDate) : undefined;
              
                return (
                    <Text>
                        {startDate.toLocaleDateString(i18n.language)} - {endDate ? endDate.toLocaleDateString(i18n.language) : t("present")}
                    </Text>
                );
            }
        },
        {
            field: "externalReference", 
            headerName: t("external_reference"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (params.row.externalReference && params.row.externalReference.length > 0) {
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text noBreak>{params.row.externalReference}</Text>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.externalReference}
                        ></ShCopyButton>
                    </Box>
                    );
                }
                return params.row.externalReference;
            }
        },
        {
            field: "totalLines",
            headerName: t("invoicelines"),
            width:144,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
    
                return params.row.totalLines;
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                // WarehouseInvoiceCard
                return (
                    <WarehouseInvoiceCard
                        onClick={() => getInvoice(params)}
                        skeleton={params.row.skeleton}
                        {...params.row}
                    />
                    // <ShTextSkeleton/>
                )
            }
        },
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetInvoicesQuery}
                config={config}
                gridActions={<GridActions handleOpen={handleOpen} handleImportOpen={handleImportOpen} handleFinalizeOpen={handleFinalizeOpen} hasModifyPrivilege={hasModifyPrivilege} handleExportClick={() => exportInvoicesModal.setOpen(true)}></GridActions>}
                title={t('all')}
                gridOptions={gridOptions}
                sortModel={{field: columns[0].field,type:"DESC"}}
                columns={columns}
                rows={data}
                onRowClick={getInvoice}
                onDataChange={(rows, response) => setIsStockhubPdf(response?.accountingSoftwareType === "stockhub_pdf")}
                selectable={canFollowUp}
                setSelected={canFollowUp ? onSelected : undefined}
                selectedItems={canFollowUp ? selectedItems : undefined}
                isRowSelectable={(row) => canFollowUp && followUpStates.includes(row.state)}
                selectedActions={
                    canFollowUp &&
                    <ShDataGridSelectedActions selectedItems={selectedItems}>
                        <DropdownButton onClick={() => sendReminderModal.setOpen(true)} icon={<MailOutlineIcon/>} text={t("send_reminder")}/>
                        <DropdownButton onClick={() => markPaidModal.setOpen(true)} icon={<EuroSymbolIcon/>} text={t("mark_as_paid")}/>
                    </ShDataGridSelectedActions>
                }
                >
            </ShDataGrid2>

            <MDynamicValues
                open={exportInvoicesModal.open}
                handleClose={() => exportInvoicesModal.setOpen(false)}
                title={t("export_invoices")}
                subtitle={t("max_range_invoice_startdate_28")}
                labelWidth={80}
                fields={[
                    { name: "relationId", label: t("relation"), type: "list", options: relationData, search: true },
                    { name: "startDate", label: t("invoice_startdate_from"), type: "date", required: true },
                    { name: "endDate", label: t("invoice_startdate_to"), type: "date", required: true }
                ]}
                onConfirm={(values) => handleExportInvoices(values)}
            />

            {spLoading && 
                <SpInvoiceDetails
                    invoiceId={invoiceId}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    // data={pickingJobData}
                /> 
            }

            {spRelationLoading && 
                <SpRelationDetails
                    relationId={relationId}
                    isExtended={isRelationExtended}
                    setIsExtended={setIsRelationExtended}
                    // data={pickingJobData}
                /> 
            }

            <MLoader
                open={loaderModal.open}
                message={t("preparing_export")}></MLoader>
            <MAddConceptInvoice onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} />
            <MImportData
                onOpen={() => importModal.setOpen(true)}
                onClose={() => importModal.setOpen(false)}
                open={importModal.open}
                handleClose={handleImportClose}

                logo={<ImportStandAloneFileLogo Icon={CallMadeOutlinedIcon} />}
                title={t("import_adjustment_charges")}
                fileType={"naheffingen"}
                columns={adjustmentChargesShipper === "stockhub" ? importColumns : []}
                notice={adjustmentChargesShipper === "stockhub" ? null : t("adjustment_charges_import_explainer")}
                exampleFile={adjustmentChargesShipper === "stockhub" ? "/Voorbeeld_naheffingimport.xlsx" : null}
                importSettings={adjustmentChargeImportSettings}
                onSaveSettings={handleAdjustmentChargesOptionsSave}
            />
            <MConfirmation
                open={finalizeModal.open}
                handleClose={handleFinalizeClose}
                title={t("finalize_all_invoices")}
                content={`${t("confirm_finalize_all_invoices")} ${getYesterDay()}`}
                confirm={handleFinalizeAllInvoices}
            />
            <MLoader
                open={finalizeLoaderModal.open}
                handleClose={handleFinalizeLoaderClose}
                message={t("finalizing_invoices")}
                responseMessage={finalizeResponseMessage}
            />
            <MConfirmation
                open={markPaidModal.open}
                handleClose={() => markPaidModal.setOpen(false)}
                title={t("mark_as_paid")}
                content={t("confirm_mark_invoices_as_paid", {count: selectedItems.length})}
                confirm={handleMarkPaid}
            />
            <MConfirmation
                open={sendReminderModal.open}
                handleClose={() => sendReminderModal.setOpen(false)}
                title={t("send_reminder")}
                content={t("confirm_send_invoice_reminders", {count: selectedItems.length})}
                confirm={handleSendReminders}
            />
        </Box>
    );
}

export default All;